import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useBPChartTooltip from "components/common/chart/bp_chart/tooltip/useBPChartTooltip";
import formatDate from "utils/formatDate";

const BPChartTooltip = ({ data, ...props }) => {
  const { getTooltipData } = useBPChartTooltip(data);

  if (props.active) {
    const tooltipData = getTooltipData(props.label);
    return (
      <div style={{ background: "white", color: "black", padding: 10 }}>
        <div style={{ fontWeight: "bold", marginBottom: 10, fontSize: 18 }}>
          {formatDate(props.label)}
        </div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>BP (mmHg)</TableCell>
                <TableCell>HR (bpm)</TableCell>
                <TableCell>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tooltipData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={index === 0 ? { fontWeight: "bold" } : null}
                  >{`${row.sValue}/${row.dValue}`}</TableCell>
                  <TableCell
                    style={index === 0 ? { fontWeight: "bold" } : null}
                  >
                    {row.hr}
                  </TableCell>
                  <TableCell
                    style={index === 0 ? { fontWeight: "bold" } : null}
                  >
                    {new Date(row.timestamp).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  } else {
    return null;
  }
};

export default BPChartTooltip;
